import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      kicker="Document N°01 · Privacy"
      title="Privacy Policy."
      updated="December 2025"
    >
      <p>
        <strong>RTAMA LTD</strong> (registration number{" "}
        <strong>HE433506</strong>), with registered office at{" "}
        <em>Griva Digeni Avenue 51, Athineon Court, Office 202, 8047, Paphos,
        Cyprus</em> (&ldquo;<strong>RTAMA</strong>&rdquo;, &ldquo;we&rdquo;,
        &ldquo;our&rdquo;, or &ldquo;us&rdquo;), is a private limited company
        registered in the Republic of Cyprus providing influencer management
        services to clients worldwide. This Privacy Policy explains how we
        collect, use, and protect information about you when you visit our
        website or interact with our services.
      </p>

      <h2>1. Who we are</h2>
      <p>
        <strong>RTAMA LTD</strong><br />
        Registration number: HE433506<br />
        Registered office: Griva Digeni Avenue 51, Athineon Court, Office 202,
        8047, Paphos, Cyprus<br />
        Contact: <a href="mailto:rtamaltd@gmail.com">rtamaltd@gmail.com</a>
      </p>

      <h2>2. What we collect</h2>
      <ul>
        <li>
          <strong>Contact information</strong> you submit through our forms
          (name, email, company / handle, message).
        </li>
        <li>
          <strong>Technical data</strong> such as IP address, browser type, and
          basic usage logs, collected automatically by our hosting and
          analytics providers.
        </li>
        <li>
          <strong>Communications</strong> exchanged between you and our team
          (email, messaging, contracts).
        </li>
      </ul>

      <h2>3. How we use it</h2>
      <ul>
        <li>To reply to your enquiry and provide our services.</li>
        <li>To maintain and improve the website and our offering.</li>
        <li>To comply with applicable legal and tax obligations.</li>
      </ul>

      <h2>4. Legal basis (GDPR)</h2>
      <p>
        We process personal data on the legal bases of (a) consent, (b)
        contract, (c) legitimate interest in operating our studio, and (d)
        compliance with legal obligations.
      </p>

      <h2>5. Sharing</h2>
      <p>
        We never sell your personal data. We share data only with service
        providers strictly necessary to run our business (e.g., hosting,
        email, accounting) under appropriate data-processing agreements.
      </p>

      <h2>6. International transfers</h2>
      <p>
        As we work worldwide, your data may be processed outside the European
        Economic Area. Where this happens, we rely on adequacy decisions or
        Standard Contractual Clauses.
      </p>

      <h2>7. Retention</h2>
      <p>
        We keep lead and contact data for up to 24 months from last
        interaction, unless a longer period is required by law or by an active
        contract.
      </p>

      <h2>8. Your rights</h2>
      <p>
        You have the right to access, rectify, delete, restrict, or object to
        our processing of your data, and the right to data portability. To
        exercise these rights, email{" "}
        <a href="mailto:rtamaltd@gmail.com">rtamaltd@gmail.com</a>. You may
        also lodge a complaint with the Cyprus Commissioner for Personal Data
        Protection.
      </p>

      <h2>9. Security</h2>
      <p>
        We apply reasonable technical and organisational measures to protect
        your data, including encrypted transport (HTTPS) and access controls.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update this Policy from time to time. Material changes will be
        reflected via an updated &ldquo;Last updated&rdquo; date at the top of
        this page.
      </p>
    </LegalLayout>
  );
}
